module.exports = __webpack_public_path__ + "./images/d6e4f26bf13cbb619f86de4f25b816a3.webp";